(() => {
  if (window.__stovebossGuideBridgeBound) return;
  window.__stovebossGuideBridgeBound = true;
  document.addEventListener('click', (event) => {
    const el = event.target.closest('[data-stoveboss-guide-cta]');
    if (!el) return;
    const aside = el.closest('[data-stoveboss-guide-bridge]');
    const url = new URL(el.href, window.location.origin);
    if (url.origin !== window.location.origin) return;
    if (!window.Shopify?.analytics?.publish) return;
    Shopify.analytics.publish('stoveboss:guide_bridge_click', {
      destination_type: el.dataset.destinationType || aside?.dataset.destinationType || '',
      destination_path: url.pathname,
      placement: 'guide_bridge'
    });
  }, { capture: true });
})();
